import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ApplyIdKey, ApplyIdState } from "./apply-id-reducer";

export const selectApplyIdState = createFeatureSelector<ApplyIdState>(ApplyIdKey);

export const selectValidSelection = createSelector(selectApplyIdState, (state) => state.validSelection);